"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStrategyManagerContract = exports.getPoolContract = exports.getERC20Contract = exports.getLiquidityHelperContract = exports.getStrategyContract = void 0;
var address_1 = require("@ethersproject/address");
var types_1 = require("../../abis/types");
function getStrategyContract(address, signerOrProvider) {
    (0, address_1.getAddress)(address);
    return types_1.Strategy__factory.connect(address, signerOrProvider);
}
exports.getStrategyContract = getStrategyContract;
function getStrategyManagerContract(address, signerOrProvider) {
    (0, address_1.getAddress)(address);
    return types_1.StrategyManager__factory.connect(address, signerOrProvider);
}
exports.getStrategyManagerContract = getStrategyManagerContract;
function getERC20Contract(address, signerOrProvider) {
    (0, address_1.getAddress)(address);
    return types_1.ERC20__factory.connect(address, signerOrProvider);
}
exports.getERC20Contract = getERC20Contract;
function getLiquidityHelperContract(address, signerOrProvider) {
    (0, address_1.getAddress)(address);
    return types_1.LiquidityHelper__factory.connect(address, signerOrProvider);
}
exports.getLiquidityHelperContract = getLiquidityHelperContract;
function getPoolContract(address, signerOrProvider) {
    (0, address_1.getAddress)(address);
    return types_1.Pool__factory.connect(address, signerOrProvider);
}
exports.getPoolContract = getPoolContract;
//# sourceMappingURL=index.js.map